import React, {useState} from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {withI18n} from '../../hocs'
import {InputField} from '../../atoms'
import ActionDialog from '../action-dialog'
import * as S from './styled'
import Tooltip from '@material-ui/core/Tooltip'

const ModalChangePass = ({ open, handleClose, i18n, onSubmit, forceResetPassword }) => {
  const [oldPass, setOldPass] = useState('')
  const handleChangeOldPass = value => setOldPass(value)

  const [newPass, setNewPass] = useState('')
  const handleChangeNewPass = value => setNewPass(value)

  const [repPass, setRepPass] = useState('')
  const handleChangeRepPass = value => setRepPass(value)

  const onClickSubmit = e => {
    e && e.preventDefault()

    if (!onSubmit || !newPass) return
    // Se devuelve la petición del padre para el spinner; los campos se vacían solo si ha ido bien
    return Promise.resolve(onSubmit({ newPass, oldPass })).then(() => {
      setNewPass('')
      setRepPass('')
      setOldPass('')
    })
  }


  let validatePass = new RegExp("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$€%^&*(),.?\":{}|<>_-])(?=.{12,})")
  let validated = !_.isEmpty(oldPass) && !_.isEmpty(newPass) && repPass === newPass && newPass.match(validatePass)
  let passError = !_.isEmpty(repPass) && repPass !== newPass ? i18n.modalChangePass.errors.passNotMatch : ''
  let strongPasswordError = !_.isEmpty(newPass) && !newPass.match(validatePass) ? i18n.modalChangePass.errors.passNotStrongEnough : ''

  return (
    <ActionDialog
      open={open}
      title={forceResetPassword ? i18n.modalChangePass.forceTitle : i18n.modalChangePass.title}
      onClose={handleClose}
      onConfirm={onClickSubmit}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.modalChangePass.submit}
      confirmDisabled={!validated}
      disableBackdropClose
    >
      <S.Body>
        <S.Info>{i18n.modalChangePass.info}</S.Info>
        <div>
          <S.Label>{i18n.modalChangePass.oldPass}*</S.Label>
          <InputField
            name="oldPass"
            type="password"
            placeholder={i18n.modalChangePass.oldPass}
            handleOnChange={handleChangeOldPass}
            value={oldPass}
          />
        </div>
        <div>
          <Tooltip title={i18n.modalChangePass.errors.passNotStrongEnough} placement="right" arrow>
            <S.Label>{i18n.modalChangePass.newPass}*</S.Label>
          </Tooltip>
          <InputField
            name="newPass"
            type="password"
            placeholder={i18n.modalChangePass.newPass}
            handleOnChange={handleChangeNewPass}
            value={newPass}
          />
          {strongPasswordError && <S.Error>{strongPasswordError}</S.Error>}
        </div>
        <div>
          <S.Label>{i18n.modalChangePass.repPass}*</S.Label>
          <InputField
            name="repPass"
            type="password"
            placeholder={i18n.modalChangePass.repPass}
            handleOnChange={handleChangeRepPass}
            value={repPass}
          />
          {passError && <S.Error>{passError}</S.Error>}
        </div>
      </S.Body>
    </ActionDialog>
  )
}

ModalChangePass.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
}

const enharce = compose(withI18n)

export default enharce(ModalChangePass)
